export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7202.3c11811f.jpg";